import CirculoError from "../../../../assets/images/generico/CirculoError";
import CirculoTildeOk from "../../../../assets/images/generico/CirculoTildeOk";
import { ContainerResumenLista, Item } from "./localStyle";

const ResumenLista = ({lista}) => {

    return (
        <ContainerResumenLista>
            {
                lista.map((item, index) => {
                    return (
                        <Item key={index}>
                          {item.estado ? <CirculoTildeOk /> : <CirculoError />}
                          <span className="rb18m">{item.nombre}</span>
                        </Item>
                    )
                })
            }    
        </ContainerResumenLista>
    )
}

export default ResumenLista; 